var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/base', 'model/currency'], function($, core, BaseCollection, CurrencyModel) {
  var CurrencyCollection;
  return CurrencyCollection = (function(_super) {

    __extends(CurrencyCollection, _super);

    function CurrencyCollection() {
      CurrencyCollection.__super__.constructor.apply(this, arguments);
    }

    CurrencyCollection.prototype.path = core.getConfig().apiPrefix + 'currency.json';

    CurrencyCollection.prototype.model = CurrencyModel;

    return CurrencyCollection;

  })(BaseCollection);
});
